<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <div [innerHTML]="message"></div>
</div>

<div mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">OK</button>
</div>